<template>
  <ErrorMessage errorCode="404" />
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { ErrorMessage } from '@/common/components/Message'

@Component({ components: { ErrorMessage } })
class NotFoundView extends Vue {}

export default NotFoundView
</script>
